import { useEffect } from "react";
import { format } from "date-fns";
import { enGB } from "date-fns/locale";
import { useAppSelector, useAppDispatch } from "../../store/hooks";
import { useNavigate } from "react-router-dom";
import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
} from "@mui/material";
import { fetchSubmissions } from "../../store/slices/registrationSlice";

const Submissions = () => {
    const navigate = useNavigate();
    const { submissions, fetchingSubmissions: fetching } = useAppSelector(
        (state) => state.registrationReducer,
    );
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (submissions.length === 0) dispatch(fetchSubmissions());
    }, [dispatch, submissions.length]);

    if (fetching) return <h2 style={{ margin: "10px" }}>Loading ...</h2>;
    if (submissions.length === 0) return <h2 style={{ margin: "10px" }}>No entries</h2>;

    return (
        <Table size="small">
            <TableHead>
                <TableRow style={{ height: "37px" }}>
                    <TableCell>Date</TableCell>
                    <TableCell>Company</TableCell>
                    <TableCell>Policy Number</TableCell>
                    <TableCell>Contact</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {submissions.map((s) => (
                    <TableRow
                        onClick={() => navigate(`/registration/${s.id}`)}
                        key={s.id}
                        style={{ cursor: "pointer" }}
                    >
                        <TableCell>{format(new Date(s.createdOn), "Pp", { locale: enGB })}</TableCell>
                        <TableCell>{s.companyName}</TableCell>
                        <TableCell>{s.policyNumber}</TableCell>
                        <TableCell>
                            {s.firstName} {s.lastName}
                        </TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    );
};

export default Submissions;
